import { render, staticRenderFns } from "./CompanyTradieList.vue?vue&type=template&id=5f7ea353&scoped=true"
import script from "./CompanyTradieList.vue?vue&type=script&lang=js"
export * from "./CompanyTradieList.vue?vue&type=script&lang=js"
import style0 from "./CompanyTradieList.vue?vue&type=style&index=0&id=5f7ea353&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7ea353",
  null
  
)

export default component.exports